import { render, staticRenderFns } from "./FontZhIcon.vue?vue&type=template&id=7658ed6d&"
import script from "./FontZhIcon.vue?vue&type=script&lang=js&"
export * from "./FontZhIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports